import React from "react";
import styles from "./CatchyCheckbox.module.css";
export default function CatchyCheckbox({ label, handleCheck, isActive, isDisabled }) {
  return (
    <div
      className={`${styles["inline-flex"]} ${styles["gap-2"]} w-fit`}
      onClick={() => isDisabled?"": handleCheck()}
    >
      <div
        className={`${styles["cursor-pointer"]} ${styles.checkbox} ${
          isActive ? styles.active : ""
        }`}
      ></div>
      <label>{label}</label>
    </div>
  );
}
